const state = window.teal_state = window.teal_state || {};
state.load = state.load || {};
state.load.module_init = state.load.module_init || [];
state.load.content_loaded = state.load.content_loaded || false;
state.load.asset_loaded = state.load.asset_loaded || false;
state.load.content_callbacks = state.load.content_callbacks || [];
state.load.asset_callbacks = state.load.asset_callbacks || [];

const ready_state_e = 'readystatechange';
const content_loaded_e = 'interactive';
const asset_loaded_e = 'complete';

const allow = [
	// 'expandable',
];
const disallow = [
	'slideshow-swiper',
];


const module = {
	
	/**
	 * Has this module already been initialized?
	 * @param {string} name
	 * @return {boolean}
	 */
	ran(name) {
		if (state.load.module_init.includes(name)) return true;
		
		if (allow.length && !allow.includes(name) && name !== 'load') return true;
		if (disallow.includes(name) && name !== 'load') return true;
		
		state.load.module_init.push(name);
		return false;
	},
	
	
	/**
	 * Init module
	 */
	init() {
		if (this.ran('load')) return false;
		
		document.addEventListener(ready_state_e, e => {
			if (e.target.readyState === content_loaded_e) {
				state.load.content_loaded = true;
				state.load.content_callbacks.forEach(callback => {
					callback();
				});
			} else if (e.target.readyState === asset_loaded_e) {
				state.load.asset_loaded = true;
				state.load.asset_callbacks.forEach(callback => {
					callback();
				});
			}
		});
	},
	
	
	/**
	 * Fire when content is loaded
	 * @param {function} callback
	 */
	content(callback) {
		state.load.content_callbacks.push(callback);
		
		if (state.load.content_loaded) {
			callback();
		}
	},
	
	
	/**
	 * Fire when all assets are loaded
	 * @param {function} callback
	 */
	all(callback) {
		state.load.asset_callbacks.push(callback);
		
		if (state.load.asset_loaded) {
			callback();
		}
	},
	
};

export default module;
module.init();
